import React, {ReactElement} from 'react';
import {DeviceType} from '../../../incase-domain/common/DeviceType.enum';
import {ELEMENT} from '../../../incase-domain/elements/base/ElementTypes';
import {HtmlSlottedElement} from '../../../incase-domain/elements/html/htmlSlot';
import MultiselectQuestionElement from '../question/multiselect/MultiselectQuestionElement';
import SequenceQuestionElement from '../question/sequence/SequenceQuestionElement';
import LikertScaleQuestionElement from '../question/likertScale/LikertScaleQuestionElement';
import QuestionElement from '../question/question/QuestionElement';

interface HtmlSlottedElementPortalProps {
    element: HtmlSlottedElement;
    device?: DeviceType;
}

function HtmlSlottedElementPortal({element, device}: HtmlSlottedElementPortalProps): ReactElement | null {
    switch (element.type) {
        case ELEMENT.QUESTION:
            return <QuestionElement element={element} device={device} />;
        case ELEMENT.MULTI_SELECT:
            return <MultiselectQuestionElement element={element} device={device} />;
        case ELEMENT.SEQUENCE_QUESTION:
            return <SequenceQuestionElement element={element} device={device} />;
        case ELEMENT.LIKERT_SCALE:
            return <LikertScaleQuestionElement element={element} device={device} />;
        default:
            return null;
    }
}

export default HtmlSlottedElementPortal;
